import { ApiService } from "./NetworkHandler";
const baseUrl = '/api/v1/vendors'

export const VendorApi = {
    getVendors: async function (warehouseId) {
        const response = await ApiService.sendRequest('get', `${baseUrl}/get-for-warehouse?warehouseId=${warehouseId}`);
        return response;
    },
}